import { createAction } from 'redux-actions';
import { createRequestTypes } from 'utils';

export const REVIEW_LIST_LOAD = createRequestTypes('REVIEW_LIST_LOAD');
export const REVIEW_DETAIL_LOAD = createRequestTypes('REVIEW_DETAIL_LOAD');
export const REVIEW_UPDATE = createRequestTypes('REVIEW_UPDATE');
export const REVIEW_DELETE = createRequestTypes('REVIEW_DELETE');
export const REVIEW_SHOW_EDIT_FORM = 'REVIEW_SHOW_EDIT_FORM';

export const reviewShowEditForm = createAction(REVIEW_SHOW_EDIT_FORM);

export const reviewListLoad = createAction(REVIEW_LIST_LOAD.START);
export const reviewListLoadRequest = createAction(REVIEW_LIST_LOAD.REQUEST);
export const reviewListLoadComplete = createAction(REVIEW_LIST_LOAD.COMPLETE);
export const reviewListLoadError = createAction(REVIEW_LIST_LOAD.ERROR);

export const reviewDetailLoad = createAction(REVIEW_DETAIL_LOAD.START);
export const reviewDetailLoadRequest = createAction(REVIEW_DETAIL_LOAD.REQUEST);
export const reviewDetailLoadComplete = createAction(REVIEW_DETAIL_LOAD.COMPLETE);
export const reviewDetailLoadError = createAction(REVIEW_DETAIL_LOAD.ERROR);

export const reviewUpdate = createAction(REVIEW_UPDATE.START);
export const reviewUpdateRequest = createAction(REVIEW_UPDATE.REQUEST);
export const reviewUpdateComplete = createAction(REVIEW_UPDATE.COMPLETE);
export const reviewUpdateError = createAction(REVIEW_UPDATE.ERROR);

export const reviewDelete = createAction(REVIEW_DELETE.START);
export const reviewDeleteRequest = createAction(REVIEW_DELETE.REQUEST);
export const reviewDeleteComplete = createAction(REVIEW_DELETE.COMPLETE);
export const reviewDeleteError = createAction(REVIEW_DELETE.ERROR);
